<template>
  <div>
    <van-action-sheet v-model="isShow" :title="title">
      <div>
        <van-field
                v-model="content"
                rows="6"
                autosize
                label="备注"
                type="textarea"
                maxlength="200"
                placeholder="请输入"
                show-word-limit
        />
        <div class="b-but">
        <van-button @click="handleOk" style="background: #914D3B">确认</van-button>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
  import {Dialog} from "vant";

  export default {
    name: 'remark',
    props: {
      title: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        isShow: false,
        content: '',
        paramId: ''
      }
    },
    computed: {},
    created() {
    },
    mounted() {
    },
    methods: {
      show(content = '', paramId) {
        this.isShow = true
        this.content = content
        this.paramId = paramId
      },
      close () {
        this.isShow = false
      },
      handleOk() {
        const that = this
        Dialog.confirm({
          message: '是否确认',
        })
        .then(() => {
          that.$emit('handleOk', that.content, that.paramId)
          that.close()
        })
        .catch(() => {
        });
      }
    }
  }
</script>

<style scoped>
/deep/.van-field__label{
  width: 50px;
}
/deep/.b-but .van-button--default{
  height: 45px;
  background: #2C68E4;
  border-radius: 3px;
  width: 90%;
}
/deep/.van-field__control{
  border: 1px solid #dedede;
  border-radius: 3px;
  padding: 5px;
}
</style>
